import { useState } from "react";

import { Box, Button, ButtonProps, Typography } from "@mui/material";
import Modal from '@mui/material/Modal';
import { DeleteButtonStyled } from "common/Buttons/styled";

interface DeleteButtonProps {
  text?: string;
  confirmationText?: string;
  disabled?: boolean;
  buttonVariant?: ButtonProps["variant"];
  buttonColor?: ButtonProps["color"];
  callBack: () => void;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const DeleteButton = ({
  text = 'Delete',
  confirmationText = 'Do you really want to delete this ?',
  disabled = false,
  buttonVariant,
  buttonColor,
  callBack,
}: DeleteButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        variant={buttonVariant}
        color={buttonColor}
        onClick={handleOpen}
        disabled={disabled}
      >
        {text}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" mb={3}>
            {confirmationText}
          </Typography>
          <DeleteButtonStyled
            error
            onClick={async () => {
              await callBack()
              handleClose()
            }}
          >
            Delete
          </DeleteButtonStyled>
          <Button onClick={handleClose}>Cancel</Button>
        </Box>
      </Modal>
    </>

  );
}

export default DeleteButton;
